import { useParams } from 'react-router-dom';
import useValidarQr from '../hooks/useValidarQr';
import DocumentoPDFViewer from '../components/DocumentoPDFViewer';
import DatosPersonalesTable from '../components/DatosPersonalesTable';
import DatosHabilitacionTable from '../components/DatosHabilitacionTable';
import Header from '../components/Header';
import ValidadorFirmaButton from '../components/ValidadorFirmaButton';

function NotSignedNotice() {
  return (
    <div>
      <Header />
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <h2 className="text-danger mb-3">Documento en proceso de firma digital</h2>
        <p className="text-center" style={{ maxWidth: 640 }}>
          El documento consultado aún no posee una firma digital registrada en el sistema.
          Cuando la firma sea aplicada y el documento quede en el repositorio de firmados,
          esta página mostrará la visualización del PDF y su validación.
        </p>
      </div>
    </div>
  );
}

const hasBase64 = (s) => typeof s === 'string' && s.trim().length > 0;

export default function QRValidarPage() {
  const { tipo, personaId, hapId } = useParams();
  const { data, loading, error } = useValidarQr(tipo, personaId, hapId);

  if (loading) {
    return (
      <div>
        <Header />
        <p className="text-center mt-5">Cargando datos...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Header />
        <p className="text-center mt-5 text-danger">Error: {error.message}</p>
      </div>
    );
  }

  // La verificación SOLO se realiza de un documento firmado
  if (!data || !hasBase64(data.documentoBase64)) {
    return <NotSignedNotice />;
  }

  // ✅ Hay documento firmado: se muestra la validación completa
  return (
    <div>
      <Header />

      <DatosPersonalesTable data={data} />
      <DatosHabilitacionTable data={data} />

      <DocumentoPDFViewer base64={data.documentoBase64} />

      <div className="text-center my-4">
        <p
          className="mb-3"
          style={{
            fontSize: '1rem',
            color: '#3C8DBC',
            maxWidth: '600px',
            margin: '0 auto',
          }}
        >
          El botón "Ir al validador" lo redireccionará al validador de firma digital: <br />
          <strong>https://validadordefirmas.gob.ar/upload</strong>
        </p>

        <div className="mt-3 mb-5">
          <ValidadorFirmaButton
            base64={data.documentoBase64}
            filename={`${data.apellido || 'documento'}_${data.nroHabilitacion || hapId}.pdf`}
          />
        </div>
      </div>
    </div>
  );
}
